module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-2021-1.d382eb44.jpg";